/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitImageDetail,
    PressKitImageDetailFromJSON,
    PressKitImageDetailFromJSONTyped,
    PressKitImageDetailToJSON,
} from './PressKitImageDetail';

/**
 * 
 * @export
 * @interface GetPressKitImageDetailResponse
 */
export interface GetPressKitImageDetailResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitImageDetailResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitImageDetailResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitImageDetail}
     * @memberof GetPressKitImageDetailResponse
     */
    data: PressKitImageDetail;
}

export function GetPressKitImageDetailResponseFromJSON(json: any): GetPressKitImageDetailResponse {
    return GetPressKitImageDetailResponseFromJSONTyped(json, false);
}

export function GetPressKitImageDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitImageDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitImageDetailFromJSON(json['data']),
    };
}

export function GetPressKitImageDetailResponseToJSON(value?: GetPressKitImageDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitImageDetailToJSON(value.data),
    };
}

